import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import Icon, { IconSizes, IconVariants } from '../../components/foundations/Icon';
import { getUserData } from '../../selectors/user';
import { isFreeTierOrTrial } from '../utils';
import css from '../style.css';

function IntercomBell() {
    const userData = useSelector(getUserData) || {};
    const [unreadCount, setUnreadCount] = useState(0);

    useEffect(() => {
        if (window.Intercom) {
            window.Intercom('onUnreadCountChange', count => setUnreadCount(count));
        }
    }, []);

    if (!userData.email || isFreeTierOrTrial(userData)) {
        return null;
    }

    return (
        <button type="button" id="intercom-link" className={css.iconButton} aria-label="notifications">
            <span className={css.bellWrapper}>
                <Icon name="bell" size={IconSizes.SMALL} variant={IconVariants.WHITE} />
                {unreadCount > 0 && <span className={css.notificationBadge} />}
            </span>
        </button>
    );
}

export default IntercomBell;
